export default abstract class Transport
{
	public abstract output(message:string|string[]):Promise<void>; 
	public abstract open():Promise<void>;
	public abstract close():void;
}

